import React from "react";

import { CloudAssetDetailsPageHeader } from "../../../../../header/CloudAssetDetailsPageHeader";
import { BulkEditCloudAssetContentForm } from "./BulkEditCloudAssetContentForm";

export const BulkEditCloudAssetContentDashboard = (): JSX.Element => {
    return (
        <>
            <CloudAssetDetailsPageHeader hideActions={true} />
            <BulkEditCloudAssetContentForm />
        </>
    );
};
